import React from 'react'
import { pushContentToMatomo } from "../../utils/matomo"

function cleanFileName (file) {
  // format should be: 1234567/FileName.pdf

  let name
  let ext
  let cleanedFileName
  const maxLength = 60

  if (file.name.includes('/') && file.name.includes('.')) {
    // get everything after the "/". @TODO this really should be the first slash found.
    name = file.name.split('/')[1]
    // get all before last dot.
    name = name.split('.').slice(0, -1).join('.')

    if (name.length > maxLength) {
      // shorten and add ellipses.
      name = name.substring(0, maxLength) + '..'
    }

    // replace the extension
    ext = '.' + file.name.split('.').pop()
    cleanedFileName = name + ext
  }

  // fallback incase of bad file format
  // still render the attachment possibly removing the extension for filenames over maxLength.
  else {
    cleanedFileName = file.name.substring(0, maxLength)
  }

  return cleanedFileName
}

function pushToMatomo (attachmentName, linkText) {

  var contextData = {
    attachmentName: attachmentName
  }

  pushContentToMatomo('attachment_open','attachments','content_articlepage', 'click', linkText, contextData)  
}

const ShowAttachments = ({ attachments }) => (
  <div className='article-attachments'>

    {(attachments.length > 0) ? (
      <div className='attachments-label'><strong>Attachment(s): </strong></div>
    ) : null}

    <div className='attachments-wrapper'>

      {(attachments.length > 0)
        ? attachments.map(file => (<div className='attachment-item' key={file.id}>
          <a
            href={process.env.ATTACHMENTS_BASE_URL + '/' + encodeURIComponent(file.name)} rel='noopener noreferrer' target='_blank'
            onClick={() => pushToMatomo(file.name, cleanFileName(file))}
          >{cleanFileName(file)}
          </a>
        </div>)
        ) : null}
    </div>

  </div>
)

export default ShowAttachments
